<template>
    <div class="ms-style3" v-if="isShow">
        <div class="three">
            <!--            <div class="three-top" @click="toLink(imgMap1)">-->
            <img :src="imgMap1.adImgUrl" v-if="imgMap1&&imgMap1.id" @click="toLink(imgMap1)" class="mst-img1">
            <!--            </div>-->
            <!--            <div class="three-btm" @click="toLink(imgMap2)">-->
            <img :src="imgMap2.adImgUrl" v-if="imgMap2&&imgMap2.id"  @click="toLink(imgMap2)" class="mst-img2">
            <!--            </div>-->
        </div>
    </div>
</template>

<script>
    import {getDeptId} from "../../../utils/auth";

    export default {
        data() {
            return {
                deptId: '',
                imgMap1: {},
                imgMap2: {},
                isShow:false
            };
        },
        props: {
            imgMap: Object
        },
        async created() {
            if (this.imgMap.one) {
                this.imgMap1 = this.imgMap.one
                this.isShow=true
            }
            if (this.imgMap.two) {
                this.imgMap2 = this.imgMap.two
                this.isShow=true
            }
            this.deptId = getDeptId()
        },

        methods: {
            toLink(item) {
                if (item.adLink) {
                    this.$router.push(item.adLink)
                }
            }
        },
    };
</script>

<style lang="scss" scoped>
    .ms-style3 {
        margin-bottom: 15px;
    }

    .three {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .mst-img1 {
        flex-grow: 1;
        width: 80%;
        z-index: 10;
        height: auto; /* 保持图片比例 */
    }

    .mst-img2 {
        flex-grow: 1;
        max-width: 100%; /* 确保图片不会比容器宽 */
        height: auto; /* 保持图片比例 */
        margin-top: -90px;
    }
</style>
